var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"private_layout"}},[_c('div',{staticClass:"container-fluid dashboard_container"},[_c('top-bar'),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-12 p-5"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }